enum ActivityType {
    ChatEvent = 1,
    BackgroundHttpAction = 2,
}

export default ActivityType;
